import { Component, inject } from '@angular/core'

import { ResponseActionsComponent } from '../../../../../../../modules/shared/components/response-actions/response-actions.component'
import { PackageViewService } from '../../../../../services/reader/package-view.service'

@Component({
  standalone: true,
  selector: 'default-response-actions-tab',
  imports: [ResponseActionsComponent],
  templateUrl: './response-actions-tab.component.html',
  styleUrls: ['./response-actions-tab.component.scss'],
})
export class ResponseActionsTabComponent {
  private readonly pkgView = inject(PackageViewService)

  readonly pkg = this.pkgView.activePackage
}
